<template>

  <v-list class="pa-0">
    <v-list-tile avatar tag="div">
      <v-list-tile-avatar>
        <img :src="currentUser.photoURL" />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>
          {{ currentUser.displayName }} <v-btn icon class="error--text" @click="logout"><v-icon>power_settings_new</v-icon></v-btn>
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>

</template>

<script>
import { mapGetters } from 'vuex'
import firebase from 'firebase'

export default {
  name: 'connected-user',
  data () {
    return {
      presenceRef: firebase.database().ref('presence')
    }
  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  methods: {
    logout () {
      this.presenceRef.child(this.currentUser.uid).remove()
      firebase.auth().signOut()
      this.$store.dispatch('setUser', null)
      this.$router.push('/login')
    }
  }
}
</script>



// WEBPACK FOOTER //
// ConnectedUser.vue?c2c0016a